// extracted by mini-css-extract-plugin
export default {"message":"message_message__tyhPf"};